export const Url = {
	IMAGES: 'https://cdn.builder.io/api/v1/image/assets%',
	ICONS: 'https://img.icons8.com/?format=png&id=',
	get PLACEHOLDER() {
		return `${this.IMAGES}2F8dbd02efc10b46e386ee6111158db4f3%2F1c056486ede0465baf1ca1726872b334`;
	},
	HUBSPOT: 'https://js.hsforms.net/forms/v2.js',
} as const;
